import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useCurrentUser } from '@hooks';
import { new_session_path } from '@routes';

const LOGIN_REQUIRED_TOAST_ID = 'login-required';

const ProtectedRoute = () => {
  const location = useLocation();
  const { currentUser } = useCurrentUser(false);
  const redirectUrl = new_session_path({ returning_url: location.pathname });

  useEffect(() => {
    if (!currentUser) {
      toast.success('You must be logged in to access that page', {
        id: LOGIN_REQUIRED_TOAST_ID,
      });
    }
  }, [currentUser]);

  if (currentUser) {
    return <Outlet />;
  }

  return <Navigate to={redirectUrl} />;
};

export default ProtectedRoute;
